import { createFileRoute, redirect } from '@tanstack/react-router';
import { PAGE_IDS } from '@/constants/pages';

export const Route = createFileRoute('/')({
  beforeLoad: () => {
    throw redirect({ to: '/dashboard/$page', params: { page: PAGE_IDS.Overview }, search: { reload: undefined } });
  },
});
